export default "__VITE_ASSET__3fce8c56__"